import { BadgeCheckIcon } from '@components/common/Icons';

const MessageReceived = () => {
  return (
    <div className="my-64 flex flex-col items-center" data-cy="message-success">
      <BadgeCheckIcon className="h-36 w-36 text-coral-100" />
      <h2 className="mb-5 mt-5 font-light text-center text-dark-blue-100">
        Message received
      </h2>
      <h4 className="font-light text-center">
        Thanks for getting in touch and we’ll get back to you very soon.
      </h4>
    </div>
  );
};

export default MessageReceived;
